// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___s4fHm","root__image":"style-module__root__image___mX4dD","root__paige":"style-module__root__paige___owPZ_"};
    if(module.hot) {
      // 1697460471817
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  